"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconGroupSession = Experimental__IconGroupSession;
exports.IconGroupSession = IconGroupSession;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconGroupSession/index.tsx)
 */
function IconGroupSession(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M9.096.794a.75.75 0 0 1 .914-.538 8.01 8.01 0 0 1 5.718 5.675.75.75 0 0 1-1.45.387 6.51 6.51 0 0 0-4.644-4.61.75.75 0 0 1-.538-.914ZM.803 9.15a.75.75 0 0 1 .918.532 6.51 6.51 0 0 0 4.644 4.61.75.75 0 1 1-.375 1.452A8.01 8.01 0 0 1 .272 10.07a.75.75 0 0 1 .53-.918Zm2.697.824V10h2.612A3.495 3.495 0 0 1 7.25 8.943l.054-.03a3.432 3.432 0 0 1-.378-1.377 3.537 3.537 0 0 1 .157-1.274 3.056 3.056 0 0 1 .95-1.389 1.572 1.572 0 0 0-.36-.692 1.59 1.59 0 0 0-2.345 0 1.571 1.571 0 0 0-.326.563 2.087 2.087 0 0 0-.079.703c.029.49.236.9.535 1.257l.174.209a.5.5 0 0 1-.134.753l-.998.576a2 2 0 0 0-1 1.732ZM7 12v-.025a2 2 0 0 1 1-1.733l.998-.576a.5.5 0 0 0 .134-.753l-.174-.209c-.3-.357-.506-.767-.535-1.257a2.087 2.087 0 0 1 .08-.703c.07-.209.176-.4.325-.563a1.59 1.59 0 0 1 2.344 0c.149.163.255.354.326.563a2.1 2.1 0 0 1 .079.703c-.029.49-.236.9-.535 1.257l-.174.209a.5.5 0 0 0 .134.753l.998.576a2 2 0 0 1 1 1.732V12H7Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M11 17v-.034c0-.953.508-1.833 1.333-2.31l1.331-.768a.667.667 0 0 0 .179-1.004l-.232-.278c-.4-.477-.675-1.024-.714-1.677a2.784 2.784 0 0 1 .106-.937c.095-.278.236-.534.435-.75a2.119 2.119 0 0 1 3.124 0c.199.216.34.472.435.75.064.189.128.57.106.937-.039.653-.314 1.2-.714 1.677l-.232.278a.667.667 0 0 0 .179 1.004l1.33.768A2.667 2.667 0 0 1 19 16.966V17h-8Zm-5-2.034V15h3.437a4.668 4.668 0 0 1 1.896-2.074l.072-.04a4.598 4.598 0 0 1-.504-1.837c-.033-.57.047-1.22.209-1.699a4.077 4.077 0 0 1 .851-1.456 2.058 2.058 0 0 0-1.107-1.16 2.12 2.12 0 0 0-2.416.508c-.199.216-.34.472-.435.75-.064.189-.127.57-.106.937.039.653.314 1.2.714 1.677l.232.278a.667.667 0 0 1-.179 1.004l-1.33.768A2.667 2.667 0 0 0 6 14.966ZM13.545 2.07a1 1 0 0 1 1.218-.718c3.83.99 6.843 3.989 7.863 7.803a1 1 0 0 1-1.933.516 9.014 9.014 0 0 0-6.43-6.383 1 1 0 0 1-.718-1.218ZM2.082 13.62a1 1 0 0 1 1.224.708 9.014 9.014 0 0 0 6.43 6.384 1 1 0 0 1-.5 1.936 11.014 11.014 0 0 1-7.862-7.803 1 1 0 0 1 .708-1.225Z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconGroupSession is deprecated and will be archived soon. Use IconGroupSession instead.
 */
function Experimental__IconGroupSession(props) {
  return /*#__PURE__*/_react["default"].createElement(IconGroupSession, props);
}